import React from "react";
import "../../css/MainScreen.css";
import {
    Grid,
    Container,
    makeStyles,
} from "@material-ui/core";
import TopBar from "../../components/TopBar";
import LowerBar from "../../components/LowerBar";
import DropNotification from "../../components/DropNotification";
import { UserContext } from "../../../viewmodel/providers/user-context";
import { useLocation } from "react-router";

import routes from "../../../utils/routes.json";
import { LowerbarState } from "../../../model/lowerBarState";

const useStyles = makeStyles(() => ({
    fullWidth: {
        width: "100vw",
        maxWidth: "100vw",
        paddingLeft: "0%",
        paddingRight: "0%",
        flex: "1 1 auto",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
    },
    contentWrapper: {
        flex: "1 1 auto",
        overflowY: "auto",
    },
}));

type MainScreenProps = {
    children: React.ReactChild | React.ReactFragment | React.ReactPortal | boolean;
    lower?: boolean;
    back?: boolean;
    backPath?: string;
    fullWidth?: boolean;
    lowerBarState?: LowerbarState;
    action?: Function,
}

type PopperContainerProps = {
    notification: any,
}

function PopperContainer({ notification }: PopperContainerProps): JSX.Element {
    return (
        <div style={{ position: "fixed", left: "50%", zIndex: 100, width: "100%", maxWidth: "400px" }}>
            <DropNotification notification={notification} />
        </div>
    );
}

export default function MainScreen({ children, lower, back, backPath, fullWidth, lowerBarState, action }: MainScreenProps): JSX.Element {
    const lowerBar = lower && <LowerBar lowerBarState={lowerBarState} />;
    const classes = useStyles();

    const notifications = React.useContext(UserContext).notifications;
    const shownNotification = React.useContext(UserContext).shownNotification;

    let notificationContainer: null | JSX.Element = null;
    const location = useLocation();

    if (location.pathname !== routes.game &&
        location.pathname !== routes.notificationsPanel &&
        location.pathname !== routes.replay)
        notifications.forEach((notification) => {
            if (notification.shown === false && !notificationContainer) {
                notificationContainer = <PopperContainer notification={notification} />;
                setTimeout(() => {
                    shownNotification(notification);
                }, 50000);
            }
    });

    return (
        <Grid container direction="column" id={"GridWrapper"}>
            <TopBar back={back} path={backPath} action={action} />
            <Container className={fullWidth ? classes.fullWidth : classes.contentWrapper}>
                {notificationContainer}
                {children}
            </Container>
            {lowerBar}
        </Grid>
    );
}
